var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1145_2230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.66995C9.25413 2.10537 9.88147 2.73021 10.3199 3.4826C10.7583 4.23498 10.9927 5.08883 10.9997 5.95962C11.0067 6.8304 10.7862 7.68792 10.36 8.44729C9.93378 9.20667 9.31662 9.84155 8.56962 10.2891C7.82262 10.7367 6.97168 10.9814 6.10105 10.999C5.23042 11.0166 4.37028 10.8065 3.60578 10.3896C2.84128 9.97261 2.19894 9.36321 1.74233 8.6217C1.28573 7.8802 1.0307 7.0323 1.0025 6.16195L1 5.99995L1.0025 5.83795C1.0305 4.97444 1.28177 4.13293 1.73182 3.39544C2.18187 2.65796 2.81533 2.04967 3.57045 1.62989C4.32557 1.2101 5.17657 0.993145 6.0405 1.00017C6.90443 1.00719 7.7518 1.23795 8.5 1.66995ZM7.8535 4.64645C7.7674 4.56036 7.65285 4.50864 7.53134 4.501C7.40983 4.49336 7.2897 4.53032 7.1935 4.60495L7.1465 4.64645L5.5 6.29245L4.8535 5.64645L4.8065 5.60495C4.71029 5.53037 4.59019 5.49346 4.4687 5.50112C4.34722 5.50879 4.2327 5.5605 4.14663 5.64658C4.06056 5.73265 4.00884 5.84717 4.00118 5.96865C3.99351 6.09013 4.03043 6.21024 4.105 6.30645L4.1465 6.35345L5.1465 7.35345L5.1935 7.39495C5.28119 7.46298 5.38902 7.4999 5.5 7.4999C5.61098 7.4999 5.71881 7.46298 5.8065 7.39495L5.8535 7.35345L7.8535 5.35345L7.895 5.30645C7.96963 5.21024 8.00659 5.09012 7.99895 4.96861C7.9913 4.84709 7.93959 4.73254 7.8535 4.64645Z",
    fill: "#219653"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1145_2230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconCheckMark);
export default __webpack_public_path__ + "static/media/common_icon_check_mark.a44276075c5a40e0491780ab445451aa.svg";
export { ForwardRef as ReactComponent };